<template>
    <div>
        <label class="block text-sm font-medium text-gray-700" for="reference_probe"> Light Reference </label>
        <div class="mt-1">
            <select2 :close-on-select="true"
                     :match-alpha-numeric="true"
                     :multiple="false"
                     :options='referenceProbeInformation'
                     name="light_reference_probe"
                     placeholder="Select Reference"
            ></select2>
        </div>
    </div>

    <div>
        <label class="block text-sm font-medium text-gray-700" for="calibration_zone"> NIST Calibrated </label>
        <div class="mt-1">
            <!-- Span -->
            <toggle     v-model:value="isNist"
                        name="is_nist"></toggle>
        </div>
    </div>

    <div>
        <label class="block text-sm font-medium text-gray-700" for="bypass_s_series_bounds"> Bypass S-Series Range Limitations </label>
        <div class="mt-1">
            <toggle     v-model:value="bypassSSeriesBounds"
                        name="bypass_s_series_bounds"></toggle>
        </div>
    </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import Select2 from "@/components/elements/select2.vue";
import Toggle from "@/components/elements/toggle.vue";

export default {
    name: "AutomatedCalibrationSSeriesLight",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {Toggle, Select2},
    emits: [],
    props: {
        referenceProbeInformation: {
            type: Object,
            default: () => []
        },
    },
    data() {
        return {
            isNist: true,
            bypassSSeriesBounds: false,
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {},
    computed: {},
    watch: {},
}
</script>

<style scoped>

</style>